import {Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {Toast} from "../../../utils/Toast";
import {useTranslation} from "react-i18next";
import Papa from "papaparse";
import {FullPageLoader} from "../../../utils/FullPageLoader";
import {CSVLink} from "react-csv";
import {EAssignmentKeyStatus, EMappedOn, EUserSyncAction} from "../../../interfaces/user-sync.enums";
import {organisationService} from "../../../services/organisation.service";
import {IUserField} from "../../../interfaces/user-fields.interface";
import {userSyncService} from "../../../services/user-sync.service";
import {IAssignmentRow, IMatchEntry, IRawAssignment} from "../../../interfaces/user-sync.interface";
import {useSelector} from "react-redux";
import {getUser} from "../../auth/slice/user.selector";
import {randomId} from "../../../utils/randomId";

const csvData = [
    ["AssignmentKey", "Action", "UserRole", "UserGroups", 'UseOnce'],
    ["329548893", "K", , , ,],
    ["310615575", "P", , , ,],
    ["300036165", "N", "employee", "[Belgium,Zedelgem]", "1"],
    ["234523459", "R", , , ,],
    ["329548893", "K", , , ,],
    ["017903194", "N", "employee", "[Belgium,Zedelgem]", "1"],
];


export const ProcessUserSyncFileModal: React.FC<any> = (props) => {

    const [selectedCodes, setSelectedCodes] = useState<any>();
    const [step, setStep] = useState(1);
    const [isLoading, setIsloading] = useState(false);
    const [mappedOnKey, setMappedOnKey] = useState<EMappedOn>(EMappedOn.ASSIGNMENT_KEY);
    const [organizationFields, setOrganizationFields] = useState<IUserField[]>([]);
    const [selectedUserField, setSelectedUserField] = useState<any>();
    const [displayData, setDisplayData] = useState<IAssignmentRow[]>([]);
    const [noMatchAvailable, setNoMatchAvailable] = useState(false);

    const {t} = useTranslation('', {keyPrefix: 'ProcessUserSyncFileModal'});
    const currentUser = useSelector(getUser);
    useEffect(() => {

    }, [])
    const handleClose = () => {
        props.closeModal(false)
    }
    const parseFile = (file: any) => {
        Papa.parse(file, {
            header: true,
            complete: (results: any) => {
                const errors: any[] = [];
                const validActions = ['K', 'P', 'R', 'N'];
                let codes: any[] = []
                const userRoles: string[] = [];
                let allUserGroups: string[] = []
                let groups: any;
                setSelectedCodes(undefined)
                if (results.data.length > 0) {
                    // Skip header row
                    // const rows = results.data.slice(1);
                    const rows = results.data;

                    rows.forEach((row: any, index: number) => {
                        const rowIndex = index + 2; // Header is row 1
                        if (Object.values(row).every((value: any) => value === null || value === undefined || value?.toString()?.trim() === '')) {
                            return; // skip this row
                        }
                        const action = row?.Action?.toUpperCase();

                        // Check required fields: AssignmentKey and Action
                        if (!row?.AssignmentKey) {
                            errors.push(`Row ${rowIndex}: 'AssignmentKey' is required.`);
                        }

                        if (!action) {
                            errors.push(`Row ${rowIndex}: 'Action' is required.`);
                            return;
                        }

                        // Validate Action
                        if (!validActions.includes(action)) {
                            errors.push(`Row ${rowIndex}: Invalid 'Action' value '${row?.Action}'. Must be one of ${validActions.join(', ')}.`);
                            return;
                        }

                        // If Action is 'N', validate additional fields
                        if (action === 'N') {
                            if (!row?.UserRole) {
                                errors.push(`Row ${rowIndex}: 'UserRole' is required when Action is 'N'.`);
                            } else {
                                userRoles.push(row?.UserRole);
                            }

                            if (!row?.UserGroups || !row?.UserGroups.startsWith('[') || !row?.UserGroups.endsWith(']')) {
                                errors.push(`Row ${rowIndex}: 'UserGroups' must be a valid array string like [Belgium,Zedelgem] when Action is 'N'.`);
                            } else {
                                groups = row.UserGroups.split('[')[1].split(']')[0];
                                if (groups.includes(',')) {
                                    groups = groups.split(',');
                                }
                                let groupArray: string[] = [];
                                if (typeof groups == 'string') {
                                    groupArray = [groups]
                                } else {
                                    for (const iterator of groups) {
                                        groupArray.push(iterator.trim());
                                    }
                                }
                                allUserGroups = [...allUserGroups, ...groupArray];
                            }
                            if (row?.UseOnce !== '0' && row?.UseOnce !== '1') {
                                errors.push(`Row ${rowIndex}: 'UseOnce' must be '0' or '1' when Action is 'N'.`);
                            }
                        }
                        const actionMapper: any = {
                            K: EUserSyncAction.KEEP,
                            P: EUserSyncAction.KEEP_PUBLIC,
                            R: EUserSyncAction.REMOVE,
                            N: EUserSyncAction.NEW_ASSIGNMENT_KEY
                        }
                        codes.push({
                            "key": row.AssignmentKey,
                            "action": actionMapper[row.Action],
                            organizationRole: row.UserRole,
                        })
                    });
                    if (errors.length) {
                        Toast.fire({
                            icon: 'warning',
                            title: errors.toString(),
                            timer: 7000
                        })
                        return;
                    }
                } else {
                    Toast.fire({
                        icon: 'warning',
                        title: t('fileNotCorrect')
                    })
                    setSelectedCodes(undefined)
                    return
                }
                setSelectedCodes({
                    organization: props.id,
                    csvFileName: file.name,
                    codes: codes,
                    roles: userRoles,
                    groups: allUserGroups,
                })
            }
        });
    };

    const csvChange = (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            parseFile(e.target.files[0]);
        }
    };

    const flattenData = (dataArray: IRawAssignment[]): IAssignmentRow[] => {
        return dataArray.flatMap((entry: any) => {
            if (entry.match && entry.match.length > 0) {
                return entry.match.map((matchEntry: IMatchEntry) => ({
                    id: matchEntry?._id ?? null,
                    memberId: matchEntry?.member?._id ?? null,
                    name: matchEntry.member?.name ?? null,
                    organizationRole: matchEntry.role ?? null,
                    assignmentKey: entry.key,
                    action: entry.action,
                    assignmentKeyStatus: entry.assignmentKeyStatus,
                    checked: false,
                }));
            } else {
                // Fallback when match array is empty
                return [
                    {
                        id: randomId(),
                        name: null,
                        organizationRole: getOrgRoles(entry),
                        assignmentKey: entry.key,
                        action: entry.action,
                        assignmentKeyStatus: entry.assignmentKeyStatus,
                        checked: false,
                    },
                ];
            }
        });
    };

    const getOrgRoles = (item: any): string => {
        if (item.action == EUserSyncAction.NEW_ASSIGNMENT_KEY) {
            const selectedKey = selectedCodes.codes.find((item: any) => item.key === item.key)
            return selectedKey?.organizationRole ?? ''
        } else {
            return ''
        }
    }

    const addCodesSubmit = async () => {

        if (!selectedCodes) {
            Toast.fire({
                icon: 'warning',
                title: t('pleaseSelect')
            })
            return;
        }

        if (mappedOnKey === EMappedOn.USER_FIELD && !selectedUserField) {
            Toast.fire({
                icon: 'warning',
                title: 'Please select a user field'
            })
            return;
        }
        if (selectedUserField && selectedUserField?._id == -69) {
            Toast.fire({
                icon: 'warning',
                title: 'Please select a user field'
            })
            return;
        }

        console.log(selectedCodes, 'SELCT FICE');
        if (selectedCodes) {
            setIsloading(true);
            try {
                let data: any = {
                    "organization": props.id,
                    "mappedOn": mappedOnKey,
                    "keys": selectedCodes.codes
                }
                if (mappedOnKey === EMappedOn.USER_FIELD) {
                    data.userFieldId = selectedUserField
                }
                const result: any = await userSyncService.validateUserSync(data);
                setIsloading(false);
                if (result.statusCode == 200) {
                    // const hasMatches = result.payload.validatedUserSync.some((d: any) => Array.isArray(d.match) && d.match.length > 0);
                    // if (!hasMatches) {
                    //     setNoMatchAvailable(true);
                    // } else {
                    const sorted = sortKeysAsOriginal(data.keys, result.payload.validatedUserSync);
                    setDisplayData(flattenData(sorted as IRawAssignment[]))
                    // }
                    setStep(2)
                    Toast.fire({
                        icon: 'success',
                        title: t("fileValidateSuccessMessage")
                    })
                }
            } catch (error) {
                setIsloading(false);
                Toast.fire({
                    icon: 'warning',
                    title: t('importFailed')
                })
            }
        } else {
            Toast.fire({
                icon: 'warning',
                title: t('pleaseSelect')
            })
        }
    };

    const sortKeysAsOriginal = (original: any[], received: any[]): any[] => {
        const orderMap = new Map(original.map((item, index) => [item.key, index]));
        return [...received].sort((a, b) => {
            return (orderMap.get(a.key) ?? Infinity) - (orderMap.get(b.key) ?? Infinity);
        });
    }

    const changeHandler = (event: any) => {
        setMappedOnKey(event.target.value);
        if (event.target.value === EMappedOn.USER_FIELD) {
            getOrganizationFields()
        }
    }
    const getOrganizationFields = async () => {
        const res: any = await organisationService.getOrganizationFields(props.id);
        if (res.statusCode == 200) {
            setOrganizationFields([{_id: -69, label: 'Select User Field'}, ...res.payload.fields])
        }
    }

    const fieldChangeHandler = (event: any) => {
        setSelectedUserField(event.target.value);
    }

    const handleCheckboxChange = (id: string) => {
        setDisplayData((prev) =>
            prev?.map((row) =>
                row.id === id ? {...row, checked: !row.checked} : row
            )
        );
    };

    const validateCode = async () => {
        const checkedUsers = displayData!.filter((r) => r.checked);
        if (checkedUsers.length > 0) {
            try {
                const tempGroups = new Set(selectedCodes.groups);
                const isRandomId = (id: string) => id.startsWith('temp-');
                const keys = checkedUsers.map(user => {
                    return {
                        "key": user.assignmentKey,
                        "action": user.action.replaceAll(' ', '_'),
                        "organizationRole": user.organizationRole,
                        "assignmentKeyStatus": user.assignmentKeyStatus,
                        "groups": Array.from(tempGroups.values()),
                        "members": isRandomId(user.id) ? [] : [user.id]
                    }
                })
                const data: any = {
                    "organization": props.id,
                    "mappedOn": mappedOnKey,
                    "csvFileName": selectedCodes.csvFileName,
                    "roles": selectedCodes.roles,
                    "groups": Array.from(tempGroups.values()),
                    "keys": keys
                }

                if (mappedOnKey == EMappedOn.USER_FIELD) {
                    data.userFieldId = selectedUserField
                } else {
                    delete data.userFieldId
                }
                console.log(data, 'data');
                setIsloading(true);
                const result: any = await userSyncService.processUserSync(data);
                setIsloading(false);
                if (result.statusCode == 200) {
                    props.closeModal(true)
                    Toast.fire({
                        icon: 'success',
                        title: t('fileProcessSuccessMessage')
                    })
                }
            } catch (error) {
                setIsloading(false);
                Toast.fire({
                    icon: 'warning',
                    title: t('importFailed')
                })
            }

        } else {
            Toast.fire({
                icon: 'warning',
                title: 'Please select at least one user'
            })
        }


    }
    const openProfile = (user: any) => {
        if (currentUser._id === user.id) {
            window.open("/profile-page", "_blank");
        } else {
            if (user.action !== EUserSyncAction.NEW_ASSIGNMENT_KEY)
                window.open(`/memberprofilepage/${user.memberId}`, "_blank");
        }
    }
    const allChecked = displayData.length > 0 && displayData.every((r) => r.checked);
    const toggleSelectAll = () => {
        setDisplayData((prev) => prev.map((row) => ({...row, checked: !allChecked})));
    };

    const getAssignmentKeyMessage = (input: EAssignmentKeyStatus): string => {
        switch (input) {
            case EAssignmentKeyStatus.USED:
                return 'Assignment key already used’'
            case EAssignmentKeyStatus.ACTIVE:
                return 'Assignment key already exists and active, please check'
            case EAssignmentKeyStatus.NOT_EXIST:
                return 'No Match found'
            case EAssignmentKeyStatus.REACTIVATED:
                return 'Existing assignment key has been reactivated'
            default:
                return 'No match found'
        }
    }
    return <Modal className="up-thememodal up-invitemembersmodal" show={true} onHide={handleClose}>
        <Modal.Header className="up-modalheader" closeButton>
            <Modal.Title>{t('processNewFile')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="up-modalbody">
            {isLoading && <FullPageLoader/>}
            {step === 1 && <div className="up-modalcontentholder">
                <form className="up-formtheme up-forminvitememners">
                    <fieldset>
                        <div>
                            <CSVLink style={{textDecoration: 'underline', color: '#414141'}}
                                     filename={"sample_csv.csv"} data={csvData}>
                                <p style={{textDecoration: 'underline'}}><strong>{t('p16')} </strong></p>
                            </CSVLink>
                        </div>
                        <div className='form-group' style={{marginTop: 12}}>
                            <label style={{fontWeight: "bold", fontSize: "16px"}}>{t("selectFileMapping")}</label>
                            <div className='up-select'>
                                <select className="up-selecttheme" onChange={(e) => changeHandler(e)}>
                                    <option value={EMappedOn.ASSIGNMENT_KEY}>{t("assignmentKey")}</option>
                                    <option value={EMappedOn.USER_FIELD}>{t("userField")}</option>
                                </select>
                            </div>
                        </div>
                        {mappedOnKey === EMappedOn.USER_FIELD &&
                            <div className='form-group'>
                                <label style={{fontWeight: "bold", fontSize: "16px"}}>{t("selectUserField")}</label>
                                <div className='up-select'>
                                    <select className="up-selecttheme" onChange={(e) => fieldChangeHandler(e)}>
                                        {organizationFields && organizationFields.map((group, index) => {
                                            return <option key={index} value={group._id}>{group.label}</option>;
                                        })}
                                    </select>
                                </div>
                            </div>}
                        {!selectedCodes && <div className="up-addmoreuploadcsv">
                            <div className="up-uploadcsv">
                                <input accept=".csv" onChange={csvChange} type="file" name="file"
                                       id="up-uploadcsvfile"/>
                                <label style={{fontWeight: "bold", fontSize: "16px"}}
                                       htmlFor="up-uploadcsvfile">{t('p18')}</label>
                            </div>
                        </div>}
                        {selectedCodes && <div className="up-addmoreuploadcsv">
                            <div className="up-uploadcsv">
                                <input accept=".csv" onChange={csvChange} type="file" name="file"
                                       id="up-uploadcsvfile"/>
                                <label style={{fontWeight: "bold", fontSize: "16px"}}
                                       htmlFor="up-uploadcsvfile">{t('selectedCSVFileName')}</label>
                                <label
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                        marginLeft: 4
                                    }}>{' ' + selectedCodes.csvFileName}</label>
                            </div>
                        </div>}
                        <div className="up-formbuttonsarea">
                            <button type="button" onClick={() => addCodesSubmit()}
                                    className="up-btn">{t("next")}
                            </button>
                            <button type="button" className="up-btnclosmodal"
                                    onClick={handleClose}>{t('close')}</button>
                        </div>
                    </fieldset>
                </form>
            </div>}
            {step === 2 && <div className="up-modalcontentholder">
                {noMatchAvailable && <p>{t("noActionsAvailable")}</p>}
                {!noMatchAvailable && <>
                    {displayData && displayData.length && <table className="up-tabletheme">
                        <thead>
                        <tr>
                            <th><input
                                type="checkbox"
                                checked={allChecked}
                                onChange={toggleSelectAll}
                            /></th>
                            <th>{t("user")}</th>
                            <th>{t("assignmentKey")}</th>
                            <th>{t("action")}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {displayData.map((row) => (
                            <tr key={row.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={row.checked}
                                        onChange={() => handleCheckboxChange(row.id)}
                                    />
                                </td>
                                <td style={{cursor: 'pointer', maxWidth: '180px'}} onClick={() => openProfile(row)}>
                                    {/* @ts-ignore*/}
                                    {row?.name ? row?.name : (row.action === EUserSyncAction.NEW_ASSIGNMENT_KEY ? getAssignmentKeyMessage(row.assignmentKeyStatus) : t("noMatchFound"))}
                                    {/*<div style={{display: "flex", alignItems: "center", gap: "8px"}}>*/}
                                    {/*<img*/}
                                    {/*    src={row.image || "https://via.placeholder.com/30"}*/}
                                    {/*    alt={row.name}*/}
                                    {/*    style={{ width: 30, height: 30, borderRadius: "50%" }}*/}
                                    {/*/>*/}
                                    {/*<span style={{ marginLeft: 8 }}>{row.name}</span>*/}
                                    {/*</div>*/}
                                </td>
                                <td>{row.assignmentKey.replaceAll('_', ' ')}</td>
                                <td>{row.action}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>}

                    <div className="up-formbuttonsarea">
                        {/*disabled={!displayData?.some((r) => r.checked)}*/}
                        <button type="button"
                                onClick={() => validateCode()}
                                className="up-btn">{t("process")}
                        </button>
                        <button type="button" className="up-btnclosmodal"
                                onClick={() => setStep(1)}>{t("goBack")}
                        </button>
                    </div>
                </>}
            </div>}
        </Modal.Body>
    </Modal>
}
